<template>
  <div>
    <div class="fixed-top">
      <LoginNavbar />
    </div>
    <div class="container titleMargin">
      <div class="row mt-5">
        <div class="col-lg-6 mb-5">
          <h2 class="title_fontStyle">Sign In</h2>
          <p>&zwnj;</p>

          <form>
            <div class="form-group mb-4">
              <label for="InputEmail1" class="form_title ">Email</label>
              <input
                type="email"
                class="form-control form-control-lg"
                name="email"
                id="InputEmail1"
                aria-describedby="emailHelp"
                v-model="email"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                ref="loginEmail"
              />

              <span class="text-danger" style="font-size: 10px" v-if="errors.first('email')"
                >{{ errors.first('email') }}
              </span>
            </div>

            <div class="form-group mb-4">
              <label for="loginPassword" class="form_title ">Password</label>
              <div class="input-group mb-3">
                <input
                  type="password"
                  name="password"
                  :type="typePwd"
                  class="form-control form-control-lg"
                  id="loginPassword"
                  v-model="password"
                  autocomplete="off"
                  maxlength="20"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-validate="'required'"
                  ref="loginPassword"
                />

                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i class="fas fa-eye-slash" v-else-if="typePwd == 'text'"></i>
                  </span>
                </div>
              </div>

              <span class="text-danger" style="font-size: 10px" v-if="errors.first('password')"
                >The Password field is required
              </span>
            </div>

            <div class="form-group h6">
              <label for="loginPassword2" class="form_title ">Verification Code</label>
              <div class="d-flex justify-content-around align-items-center">
                <input
                  type="text"
                  name="text"
                  maxlength="5"
                  class="form-control mr-1"
                  id="loginPassword2"
                  v-model="Validcode"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  ref="loginPassword2"
                />
                <img
                  :src="getsrc"
                  class="img-fluid rounded"
                  @click.prevent="resetValidcode"
                  style="width: 120px; height: 35px"
                />
                <a href="#" @click.prevent="resetValidcode">
                  <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                </a>
              </div>
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('text')"
                >The Verification field is required
              </span>
            </div>

            <div class="text-muted" style="font-size: 14px">
              By signing in to your account, you agree to our
              <a href="https://www.chanchao.com.tw/en/otherMember.asp" target="_blank"> Conditions of Membership</a>
            </div>
            <p>&zwnj;</p>

            <button type="submit" class="btn btn-primary px-5" @click.prevent="loginBtn">
              Login
            </button>
          </form>

          <div class="PcDevice">
            <hr />
          </div>

          <div class="MbDevice">
            <p>&zwnj;</p>
          </div>

          <!-- <div class="linkFrame">
            <span class="mr-1">Login Problem?</span>
            <a href="https://www.chanchao.com.tw/accounts/en/forgetPw" target="_blank">
              <span class="text-primary"> Forgot Password </span>
            </a>
            /

            <span class="MbDevice">
              <span class="text-primary" @click="SliderDown"> Sing up </span>
              /
            </span>
            <a href="https://www.chanchao.com.tw/en/contact.asp" target="_blank">
              <span class="text-primary"> Contact us </span>
            </a>
          </div> -->
          <div class="linkFrame">
            <span class="mr-1">Login Problem?</span>
            <a href="https://www.chanchao.com.tw/accounts/en/forgetPw" target="_blank">
              <span class="text-primary"> Forgot Password </span>
            </a>

            /
            <a href="https://www.chanchao.com.tw/accounts/en/signup">
              <span class="text-primary"> Sign Up </span>
            </a>

            /
            <a href="https://www.chanchao.com.tw/en/contact.asp" target="_blank">
              <span class="text-primary"> Contact us </span>
            </a>
          </div>
        </div>

        <!-- <div class="col-lg-2  d-none d-lg-block ">
          <div class="d-flex justify-content-center">
            <div class="rightline "></div>
          </div>
        </div> -->

        <!-- <div class="col-lg-4 mb-5">
          <div class="MbLine"></div>

          <h5 class="title_fontStyle">To register for the show,</h5>
          <h5 class="title_fontStyle">
            please activate your Chan Chao Membership first
          </h5>
          <p>&zwnj;</p>

          <p>
            Receive our latest exhibition updates, redeem ticket events, exclusive member discounts, and subscribe to
            our newsletter and exhibition newsletter for free.
          </p>
          <p>&zwnj;</p>

          <router-link to="/Signup">
            <button class="btn btn-primary px-5 ">Sign up</button>
          </router-link>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import LoginNavbar from '@/components/LoginNavbar.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LoginNavbar,
    },

    computed: {
      ...mapGetters(['exhcode']),
    },
    data() {
      return {
        getsrc: '',
        typePwd: 'password',
        email: '',
        password: '',
        Validcode: '',
        CSRF_Token: '',
        redirect_url: '',
        alertTitle: '',
        alertText: '',
        access_token: '',
        lastUrl: '',

        OnlineExpoStatus: '',
        PreOpenTime: false,

        Nowdate: '',
        ExpoBegin: '',
        ExpoEnd: '',
        ExpoPreOpen: '',
      }
    },

    computed: {
      ...mapGetters(['exhcode']),
    },

    methods: {
      SliderDown() {
        $('html,body').animate({ scrollTop: 500 }, 'slow')
        return false
      },

      showPw() {
        const vm = this
        vm.typePwd = vm.typePwd === 'password' ? 'text' : 'password'
      },

      loginBtn() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin/v1/Login'
        const info = {
          login: vm.email,
          password: vm.password,
          Validcode: vm.Validcode,
          CSRF: vm.CSRF_Token,
          uilang: 'en',
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, info).then(function(response) {
              if (response.data == '200') {
                const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
                vm.$http.post(registerApi).then((response) => {
                  if (response.data == 200) {
                    // 判斷非參展商的時間段

                    if (vm.Nowdate < vm.ExpoBegin) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 1) {
                      window.location.replace(`https://www.chanchao.com.tw/food/onlineexpo/Landing`)
                    } else if (vm.OnlineExpoStatus == 2) {
                      let ExhUrl = sessionStorage.getItem('Exhurl')

                      if (ExhUrl) {
                        window.location.replace(ExhUrl)
                      } else {
                        window.location.replace(`https://www.chanchao.com.tw/food/onlineexpo/Home`)
                      }
                    } else if (vm.OnlineExpoStatus == 3) {
                      vm.$router.push({ path: '/Landing' })
                    }
                  } else if (response.data == 254) {
                    if (vm.Nowdate < vm.ExpoPreOpen) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoPreOpen && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 1) {
                      window.location.replace(`https://www.chanchao.com.tw/food/onlineexpo/Landing`)
                    } else if (vm.OnlineExpoStatus == 2) {
                      let ExhUrl = sessionStorage.getItem('Exhurl')

                      if (ExhUrl) {
                        window.location.replace(ExhUrl)
                      } else {
                        window.location.replace(`https://www.chanchao.com.tw/food/onlineexpo/Home`)
                      }
                    } else if (vm.OnlineExpoStatus == 3) {
                      vm.$router.push({ path: '/Landing' })
                    }
                  } else if (response.data == 252) {
                    // alert('Please complete the questionnaire to finish the visit registration')

                    window.location.replace(`https://www.chanchao.com.tw/food/onlineexpo/Landing`)
                  } else if (response.data == 251) {
                    window.location.replace(`https://www.chanchao.com.tw/en/`)
                  }
                })
              } else if (response.data == '252') {
                vm.alertText = 'Email error.'
                vm.alertError()
                vm.$refs.loginEmail.style.borderColor = 'red'
              } else if (response.data == '253') {
                vm.alertText = 'Password error.'
                vm.alertError()
                vm.$refs.loginPassword.style.borderColor = 'red'
              } else if (response.data == '254') {
                vm.alertText = 'Verification Code error.'
                vm.alertError()
                vm.$refs.loginPassword2.style.borderColor = 'red'
              } else if (response.data == '255') {
                window.location.replace(`https://www.chanchao.com.tw/en/`)
              } else if (response.data == '251') {
                vm.alertText = 'Server is busy, please try again later.'
                vm.alertError()
              } else if (response.data == '256') {
                vm.alertText = '【國外展】不為今年度參展商'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      resetValidcode() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/Validcode').then((response) => {
          vm.getsrc = response.data
        })
      },

      reload() {
        window.location.reload()
      },
    },

    mounted() {
      const vm = this

      vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/Validcode').then((response) => {
        vm.getsrc = response.data
      })

      //取得當前時間

      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitions/034B5BA8009D9545D20150D2DAE84574?lang=en`)
        .then((response) => {
          vm.Nowdate = Date.parse(new Date()).valueOf()
          vm.ExpoBegin = response.data.OnlineExpoBegin
          vm.ExpoEnd = response.data.OnlineExpoEnd
          vm.ExpoPreOpen = response.data.OnlineExpoMovein
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })

      vm.$i18n.locale = 'en'
    },
  }
</script>

<style lang="scss" scoped>
  //Swal
  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 10px;
  }

  .rightline {
    border-right: rgb(223, 220, 220) 2px solid;
    height: 300px;
  }

  .titleMargin {
    margin-top: 170px;
  }

  .MbLine {
    display: none;
    margin-bottom: 30px;
  }

  @media (max-width: 576px) {
    .titleMargin {
      margin-top: 105px;
    }

    .MbLine {
      display: block;
      border-bottom: 1px solid #e8e2e2;
    }

    .MbDevice {
      display: inline;
    }
  }
</style>
